// resources/js/woocommerce/mini-cart/dom.js
export const qs  = (sel, root = document) => root.querySelector(sel);
export const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

export const els = {
  panel   : () => document.getElementById('wk-mini-cart'),
  overlay : () => document.getElementById('wk-cart-overlay'),

  // Laat staan voor backwards compat (1e element), maar we gaan hieronder alle toggles selecteren
  toggle  : () => document.getElementById('wk-cart-toggle'),

  // NEW: alle toggles (mobile/tablet/desktop) – kies id of data-attr
  toggles : () => qsa('#wk-cart-toggle, [data-wk-cart-toggle]'),

  close   : () => {
    const p = document.getElementById('wk-mini-cart');
    return p ? p.querySelector('.wk-mini-cart__close') : null;
  },
  message : () => document.getElementById('wk-mini-cart-message'),
};

export const css = { active: 'active' };

export const xs = {
  containerId: 'wk-mini-xs',
  checkSel   : '.wk-mini-xs__chk',
  itemSel    : '.wk-mini-xs__item',
  addAllSel  : '.wk-mini-xs__add-all',
};
